// listsTableColumns.js
// AntD column definitions for the Lists table

export const listsTableColumns = [
    {
      title: "Source Code",
      dataIndex: "source_code",
      align: "center",
      width: 100,
    },
    {
      title: "List Name",
      dataIndex: "list_name",
      align: "center",
      width: 100,
    },
    {
      title: "Segment Name",
      dataIndex: "segment_name",
      align: "center",
      width: 100,
    },
    // {
    //   title: "Period",
    //   dataIndex: "period",
    //   align: "center",
    //   width: 100,
    // },
    // {
    //   title: "Available Quantity",
    //   dataIndex: "quantity",
    //   align: "center",
    //   width: 100,
    // },
    // {
    //   title: "Category",
    //   dataIndex: "category",
    //   align: "center",
    //   width: 100,
    // },
    {
      title: "Date Released",
      dataIndex: "date_released",
      align: "center",
      width: 100,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      align: "center",
      width: 100,
    },
    {
      title: "Test/Cont.",
      dataIndex: "selectTestCont",
      align: "center",
      width: 120,
    },
    {
      title: "Ship Qty",
      dataIndex: "shipQty",
      align: "center",
      width: 120,
    },
    {
      title: "Mail Qty",
      dataIndex: "mailQty",
      align: "center",
      width: 120,
    },
    {
      title: "Max/All",
      dataIndex: "selectMaxAll",
      align: "center",
      width: 100,
    },
    {
      title: "Comment",
      dataIndex: "comment",
      align: "center",
      width: 100,
    },
    {
      title: "Product Category",
      dataIndex: "productCategory",
      key: "productCategory",
      width: 100,
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      width: 100,
      render: (value) =>
        value !== undefined && value !== null && !isNaN(value)
          ? Number(value).toFixed(2)
          : "-",
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      width: 100,
    },
  ];
  
  // If you later want to inject action handlers, you can export a factory:
  // export const makeListsTableColumns = ({ onEdit, onRemove } = {}) => ([ ...columns, { title: 'Action', render: (_, record) => (...) } ]);
  